import { FileOutput } from "lucide-react"

import { Button } from "@/components/ui/button"
import { exportUrl, type ExportedRuleType } from "@/lib/api"

/**
 * `Export all` из образца. Это обычная ссылка на ручку выгрузки: имя файла и
 * тип содержимого проставляет сервер (`Content-Disposition`), собирать CSV на
 * клиенте не нужно — иначе выгрузка отдавала бы только загруженную страницу,
 * а не все правила.
 *
 * Тип — только тот, у которого формат выгрузки есть: `local` кнопке не
 * передашь, и это проверяет компилятор, а не глаз (AMEND-13 §3).
 */
export function ExportAll({ type }: { type: ExportedRuleType }) {
  return (
    <Button asChild>
      <a href={exportUrl(type)}>
        <FileOutput className="h-3.5 w-3.5" strokeWidth={2} />
        Export all
      </a>
    </Button>
  )
}
